import { ofType } from 'redux-observable';
import {
	switchMap,
	map,
	catchError,
} from 'rxjs/operators';
import { rxjsApiFetcher } from '../../../lib/general-utils';
import {
	actionTypes,
	articleActions,
	notifyActions,
} from '../../../controller';
import {
	catchErrorForEpics,
} from '../../../../lib/epic-utils';

const {
	START_FETCH_ARTICLES,
} = actionTypes;
const {
	notifyErrorAction,
} = notifyActions;
const {
	fetchArticlesSuccessAction,
	fetchArticlesFailedAction,
} = articleActions;

export function fetchArticlesEpic(action$) {
	return action$.pipe(
		ofType(START_FETCH_ARTICLES),
		switchMap(() =>
			rxjsApiFetcher
				.get('articles')
				.pipe(
					map(payload => payload.response),
					map(articles => fetchArticlesSuccessAction(articles)),
					catchError(error => catchErrorForEpics(error, fetchArticlesFailedAction, notifyErrorAction)),
				),
		),
	);
}
